export const MAX_TRAVEL_INDEX = 2160; // 90 days
